import { render } from "./ColliEntrataView.vue?vue&type=template&id=6d52a2f0&scoped=true"
import script from "./ColliEntrataView.vue?vue&type=script&lang=js"
export * from "./ColliEntrataView.vue?vue&type=script&lang=js"

import "./ColliEntrataView.vue?vue&type=style&index=0&id=6d52a2f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d52a2f0"]])

export default __exports__